import React from 'react';
import Footer from '../../molecules/Footer';
import Header from '../../molecules/Header';
import { useSelector } from 'react-redux';
import { getMessageFromMasterInfo, MESSAGE_MASTER_KEYS } from '@common/redux/reducers/MasterInfoReducer';
import { CustomerAppState } from '../../../redux/modules/store';
import OptinMailErrorContent from '../../organisms/OptinMailErrorContent';

/**
 * メール受信の許諾エラー画面
 */
const OptinMailError: React.FC = () => {
  const masterInfo = useSelector((state: CustomerAppState) => state.masterInfo);
  // メール受信の許諾エラー画面タイトル
  const notFoundPageTitle = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0007);
  // メール受信の許諾エラー画面タイトル
  const notFoundPageText = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0008);

  return (
    <div>
      <Header />
      <OptinMailErrorContent title={notFoundPageTitle} detail={notFoundPageText} />
      <Footer />
    </div>
  );
};

export default OptinMailError;
